import { useState } from 'react'
import styled from 'styled-components'
import { nav } from 'tiny-react-router'
import { useAccountStore } from '../../state'
import Vipps from '../../graphics/vipps.svg'
import Roaster from './roaster.png'
import DevLogin from '../DevLogin'

export default function Splash() {
  const account = useAccountStore(s => s.account)
  const [showDevLogin, setShowDevLogin] = useState(false)

  const handleLoginVipps = () => {
    window.location = '/api/login/vipps/request'
  }

  const handleOrderClick = () => {
    if (account != null) return nav('/account')
    else handleLoginVipps()
  }

  return (
    <>
      {showDevLogin && <DevLogin onClose={() => setShowDevLogin(false)} />}
      <Section>
        <SplashImage src={Roaster} alt="Bøllefrø kafferøster" />
        <SplashText>
          <h1>Bøllefrø</h1>
          <h2>Spesialkaffe, enkelt.</h2>
          <p>
            Bøllefrø er et mikrorøsteri.<br/>
            Vi røster og leverer kaffe av topp kvalitet som du elsker.<br/>
            Vårt mål er å få spesialkaffe hjem til deg så enkelt som mulig.
          </p>
          <div className="buttons">
            <button onClick={handleOrderClick}>Bestill nå!</button>
            <button onClick={() => nav('/blog')}>Blogg</button>
            { !account && (
              <>
                <VippsLoginButton onClick={handleLoginVipps}>
                  Login med <img src={Vipps} alt="Vipps logo" />
                </VippsLoginButton>
                {import.meta.env.VITE_ENV === 'development' && (
                  <DevLoginButton onClick={() => setShowDevLogin(true)}>
                    Dev Login
                  </DevLoginButton>
                )}
              </>
            )}
          </div>
        </SplashText>
      </Section>
    </>
  )
}

const Section = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--color-splash-yellow);
  padding: 4% 2%;
  gap: 5%;
  position: relative;
`

const SplashImage = styled.img`
  width: 300px;
  height: 270px;
  @media (max-width: 768px) {
    width: 160px;
    height: 145px;
  }
`

const SplashText = styled.div`
  @media (max-width: 768px) {
    p {
      display: none;
      font-size: 0.7em;
    }
  }
  & h1 {
    margin-bottom: 0px;
    @media (max-width: 768px) {
      font-size: 1.2em;
    }
  }
  & h2 {
    font-style: italic;
    margin-top: 10px;
    @media (max-width: 768px) {
      font-size: 1em;
    }
  }
  & .buttons {
    display: flex;
    flex-direction: row;
    gap: 5px;
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
  & button {
    color: white;
    background-color: var(--color-splash-purple);
    padding: 8px 10px;
    border: 2px solid white;
    border-radius: 10px;
    font-weight: bold;
    cursor: pointer;
  }
`

const VippsLoginButton = styled.div`
  color: white;
  background-color: var(--color-vipps);
  border-radius: 10px;
  border: 2px solid white;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
  padding: 5px 10px;
  cursor: pointer;
  & img {
    height: 10px;
    margin-top: 5px;
    padding: 5px;
  }
`

const DevLoginButton = styled.div`
  color: white;
  background-color: var(--color-splash-purple);
  border-radius: 10px;
  border: 2px solid white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  padding: 8px 10px;
  cursor: pointer;
`
